import { useState } from "react";
import { uploadFile } from "../services/cloudinary";

export function useFileUpload(initialFiles = []) {
  const [files, setFiles] = useState(initialFiles);
  const [uploading, setUploading] = useState(false);

  const addFiles = async (fileList) => {
    const selected = Array.from(fileList);
    setUploading(true);

    for (const file of selected) {
      const isVideo = file.type.startsWith("video");
      const maxSize = isVideo ? 200 * 1024 * 1024 : 20 * 1024 * 1024;

      if (file.size > maxSize) {
        alert(`"${file.name}" es demasiado grande. Max: ${isVideo ? "200MB" : "20MB"}`);
        continue;
      }

      const tempId = `${Date.now()}-${Math.random()}`;
      const localUrl = URL.createObjectURL(file);

      setFiles(prev => [...prev, { id: tempId, name: file.name, type: file.type, isVideo, url: localUrl, uploading: true, progress: 0 }]);

      try {
        const result = await uploadFile(file, (pct) => {
          setFiles(prev => prev.map(f => f.id === tempId ? { ...f, progress: pct } : f));
        });

        setFiles(prev => prev.map(f =>
          f.id === tempId ? { id: tempId, name: file.name, type: file.type, isVideo, url: result.url, publicId: result.publicId, uploading: false, progress: 100 } : f
        ));
      } catch (err) {
        alert(`Error subiendo "${file.name}": ${err.message}`);
        setFiles(prev => prev.filter(f => f.id !== tempId));
      }
    }

    setUploading(false);
  };

  const removeFile = (id) => setFiles(prev => prev.filter(f => f.id !== id));
  const clearFiles = () => setFiles([]);

  return { files, addFiles, removeFile, clearFiles, uploading };
}
